import type { SessionUser } from '../state/session.js';

export const IS_DEMO: boolean = (() => {
  if (typeof window === 'undefined') return false;
  if (new URLSearchParams(window.location.search).get('demo') === '1') return true;
  if (import.meta.env.VITE_API_URL) return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (host.endsWith('.local')) return false;
  return true;
})();

export const DEMO_USER: SessionUser = {
  id: 'demo-admin-sara',
  name: 'Sara Mahmood',
  email: 'admin@raahi.test',
  phone: '+923009999999',
  role: 'admin',
};

export const DEMO_TOKENS = {
  accessToken: 'demo-admin-access',
  refreshToken: 'demo-admin-refresh',
};
